<template>
  <div class="history">
    <div class="center-x-y">
      <h1>Histórico</h1>
    </div>
    <div class="input-search">
      <v-text-field v-model="search" outlined append-icon="mdi-magnify" />
    </div>
    <v-tabs class="my-31" v-model="tab">
      <v-tab>Positivo</v-tab>
      <v-tab>Negativo</v-tab>
      <v-tab>Análise presencial</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="getPositive"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <!-- Ignorar esse erro pq o eslint é bugado -->
          <template v-slot:item.actions="{ item }">
            <v-icon small class="icon mr-4" @click.prevent="_edit(item)"
              >mdi-image-search-outline</v-icon
            >
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="getNegative"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <!-- Ignorar esse erro pq o eslint é bugado -->
          <template v-slot:item.actions="{ item }">
            <v-icon small class="icon mr-4" @click.prevent="_edit(item)"
              >mdi-image-search-outline</v-icon
            >
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="getAnalyzePresential"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <!-- Ignorar esse erro pq o eslint é bugado -->
          <template v-slot:item.actions="{ item }">
            <v-icon small class="icon mr-4" @click.prevent="_edit(item)"
              >mdi-image-search-outline</v-icon
            >
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <dialog-monitoring :showActions="false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "history",
  data: () => ({
    tab: null,
    //dialog
    itemDialog: {},

    search: null,

    headers: [
      {
        text: "Data",
        align: "start",
        value: "date",
        sortable: false
      },
      { text: "Agriculor", value: "name" },
      { text: "CPF", value: "cpf" },
      { text: "Cultivares", value: "cultivars" },
      { text: "Ações", value: "actions", sortable: false }
    ]
  }),
  components: {
    "dialog-monitoring": () => import("../components/dialog/index.vue")
  },
  computed: {
    ...mapGetters({
      getPositive: "monitoring/getPositive",
      getNegative: "monitoring/getNegative",
      getAnalyzePresential: "monitoring/getAnalyzePresential"
    })
  },
  methods: {
    ...mapActions({
      actionLoadPositive: "monitoring/actionLoadPositive",
      actionLoadNegative: "monitoring/actionLoadNegative",
      actionLoadAnalyzePresential: "monitoring/actionLoadAnalyzePresential",
      actionShowDialog: "dialog/actionShowDialog",
      actionSetItem: "dialog/actionSetItem"
    }),

    _edit(item) {
      this.actionSetItem(item.id);
      this.actionShowDialog();
    }
  },
  created() {
    this.actionLoadPositive();
    this.actionLoadNegative();
    this.actionLoadAnalyzePresential();
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin: 1rem 0 1rem 0;
}
.input-search {
  max-width: 50%;
}
@media only screen and (max-width: 600px) {
  .input-search {
    max-width: 300px;
  }
}
@media only screen and (min-width: 1000px) {
  .input-search {
    max-width: 30%;
  }
}
</style>
